(function () {
  function getRootUrl() {
    if (window.Shopify && Shopify.routes && Shopify.routes.root) {
      return Shopify.routes.root;
    }

    return '/';
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[char];
    });
  }

  function formatMoney(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents);
      }

      return new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP',
        maximumFractionDigits: 0
      }).format(cents / 100);
    } catch (error) {
      return '$' + Math.round(cents / 100).toLocaleString('es-CO');
    }
  }

  function getRandomIndex(max) {
    if (window.crypto && window.crypto.getRandomValues) {
      var array = new Uint32Array(1);
      window.crypto.getRandomValues(array);
      return array[0] % max;
    }

    return Math.floor(Math.random() * max);
  }

  function shuffleArray(items) {
    var shuffled = items.slice();

    for (var i = shuffled.length - 1; i > 0; i--) {
      var j = getRandomIndex(i + 1);
      var temp = shuffled[i];
      shuffled[i] = shuffled[j];
      shuffled[j] = temp;
    }

    return shuffled;
  }

  function getProductImage(product) {
    if (!product.featured_image) return '';

    if (typeof product.featured_image === 'string') {
      return product.featured_image;
    }

    if (product.featured_image.url) {
      return product.featured_image.url;
    }

    if (product.featured_image.src) {
      return product.featured_image.src;
    }

    return '';
  }

  function buildRecommendationCard(product) {
    var image = getProductImage(product);
    var price = product.price || product.price_min || 0;
    var handle = product.handle || '';
    var url = product.url || (handle ? getRootUrl() + 'products/' + handle : '#');

    return `
      <article
        class="tb-cross-sell__card"
        data-product-id="${product.id}"
        data-product-handle="${escapeHtml(handle)}"
      >
        <a class="tb-cross-sell__image" href="${url}">
          ${
            image
              ? `<img src="${image}" alt="${escapeHtml(product.title)}" loading="lazy" width="500" height="500">`
              : ''
          }
        </a>

        <div class="tb-cross-sell__content">
          ${product.vendor ? `<p class="tb-cross-sell__vendor">${escapeHtml(product.vendor)}</p>` : ''}

          <a class="tb-cross-sell__name" href="${url}">
            ${escapeHtml(product.title)}
          </a>

          <p class="tb-cross-sell__price">
            ${formatMoney(price)}
          </p>

          <quick-view-modal class="tb-cross-sell__quick-view">
            <button
              class="tb-cross-sell__button"
              type="button"
              data-product-handle="${escapeHtml(handle)}"
            >
              + Al carrito
            </button>
          </quick-view-modal>
        </div>
      </article>
    `;
  }

  function getCartProductIds(section) {
    return String(section.dataset.cartProductIds || '')
      .split(',')
      .map(function (id) {
        return id.trim();
      })
      .filter(Boolean);
  }

  function fetchComplementaryProducts(productId) {
    var endpoint =
      getRootUrl() +
      'recommendations/products.json?product_id=' +
      encodeURIComponent(productId) +
      '&limit=10&intent=complementary';

    return fetch(endpoint, {
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          return { products: [] };
        }

        return response.json();
      })
      .then(function (data) {
        return data.products || [];
      })
      .catch(function () {
        return [];
      });
  }

  function uniqueProducts(products, cartProductIds) {
    var seen = {};
    var cartMap = {};

    cartProductIds.forEach(function (id) {
      cartMap[String(id)] = true;
    });

    return products.filter(function (product) {
      var productId = String(product.id);

      if (!productId || seen[productId] || cartMap[productId]) {
        return false;
      }

      seen[productId] = true;

      if (product.available === false) {
        return false;
      }

      return true;
    });
  }

  function getFallbackCards(section, excludedProductIds) {
    var excluded = {};

    excludedProductIds.forEach(function (id) {
      excluded[String(id)] = true;
    });

    return Array.prototype.slice
      .call(section.querySelectorAll('[data-tb-fallback-card]'))
      .filter(function (card) {
        var productId = String(card.dataset.productId || '');

        return productId && !excluded[productId];
      });
  }

  function renderMixedRecommendations(section, complementaryProducts) {
    var itemsWrapper = section.querySelector('.tb-cross-sell__items');

    if (!itemsWrapper) return;

    var displayLimit = Number(section.dataset.displayLimit || 4);
    var cartProductIds = getCartProductIds(section);

    var cleanComplementaryProducts = uniqueProducts(
      complementaryProducts,
      cartProductIds
    );

    var selectedComplementaryProducts = cleanComplementaryProducts.slice(
      0,
      displayLimit
    );

    var selectedIds = cartProductIds.concat(
      selectedComplementaryProducts.map(function (product) {
        return String(product.id);
      })
    );

    var complementaryMarkup = selectedComplementaryProducts
      .map(buildRecommendationCard)
      .join('');

    var missingCount = displayLimit - selectedComplementaryProducts.length;

    var fallbackCards = [];

    if (missingCount > 0) {
      fallbackCards = shuffleArray(getFallbackCards(section, selectedIds)).slice(
        0,
        missingCount
      );
    }

    itemsWrapper.innerHTML = complementaryMarkup;

    fallbackCards.forEach(function (card) {
      card.style.display = '';
      itemsWrapper.appendChild(card);
    });

    if (!itemsWrapper.querySelector('.tb-cross-sell__card')) {
      section.hidden = true;
    }
  }

  function initCrossSellSection(section) {
    if (!section || section.dataset.tbReady === 'true') return;

    section.dataset.tbReady = 'true';

    var cartProductIds = getCartProductIds(section);

    if (!cartProductIds.length) {
      section.hidden = true;
      return;
    }

    Promise.all(cartProductIds.map(fetchComplementaryProducts))
      .then(function (results) {
        var complementaryProducts = [];

        results.forEach(function (products) {
          complementaryProducts = complementaryProducts.concat(products);
        });

        renderMixedRecommendations(section, complementaryProducts);
      })
      .catch(function () {
        renderMixedRecommendations(section, []);
      });
  }

  function initCrossSell() {
    document
      .querySelectorAll('[data-tb-cross-sell-list]')
      .forEach(initCrossSellSection);
  }

  document.addEventListener('DOMContentLoaded', initCrossSell);
  window.addEventListener('load', initCrossSell);
  document.addEventListener('shopify:section:load', initCrossSell);

  setTimeout(initCrossSell, 300);
  setTimeout(initCrossSell, 1000);

  if (document.body) {
    var observer = new MutationObserver(function () {
      initCrossSell();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();